export default __webpack_public_path__ + "static/fx-pro-66500a8073ffda63835addd7810e7550.svg";